import { render, staticRenderFns } from "./edital.vue?vue&type=template&id=1cb3be02&"
import script from "./edital.vue?vue&type=script&lang=js&"
export * from "./edital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports